import { createTheme } from '@mui/material';

export const LightTheme = createTheme({
    palette: {
        primary: {
            main: '#00A351',
            contrastText: '#000000',
        },
        secondary: {
            main: '#FFFFFF',
            contrastText: '#000000',
        },
        background: {
            default: '#F9F9F9',
            paper: '#FFFFFF',
        },
    },
    typography: {
        allVariants: {
            color: 'black'
        }
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                },
            },
        },
        MuiAccordion: {
            defaultProps: {
                square: true,
                disableGutters: true,
            },
            styleOverrides: {
                root: {
                    borderRadius: '30px',
                },
            },
        },
        MuiButton: {
        styleOverrides: {
            root: {
                borderRadius: '25px',
                // color: 'white'
            }
        }
        },
    }
});

